import { render, staticRenderFns } from "./MoneyQuestion.vue?vue&type=template&id=77e4b1b2"
import script from "./MoneyQuestion.vue?vue&type=script&lang=js"
export * from "./MoneyQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports